import { render, staticRenderFns } from "./FormItemCollectionItemLabelAndValue.vue?vue&type=template&id=0d3c711f&scoped=true"
import script from "./FormItemCollectionItemLabelAndValue.vue?vue&type=script&lang=js"
export * from "./FormItemCollectionItemLabelAndValue.vue?vue&type=script&lang=js"
import style0 from "./FormItemCollectionItemLabelAndValue.vue?vue&type=style&index=0&id=0d3c711f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3c711f",
  null
  
)

export default component.exports